import React from "react";
import OverviewSection from "@widgets/pos/orders/details/section/OverviewSection";
import {twJoin} from "tailwind-merge";
import {defaultBorderColor, Icon, EmptyState as PeggirkitEmptyState} from "peggirkit";
import {ListBulletIcon} from "@heroicons/react/20/solid";
import {FormattedMessage} from "react-intl";

const EmptyState = () => {
    return (
        <OverviewSection>
            <div className={"w-full h-full flex items-center justify-center"}>
                <PeggirkitEmptyState
                    containerClassname={twJoin("border border-2 rounded-xl border-dashed p-6", defaultBorderColor)}
                    icon={<Icon icon={ListBulletIcon}/>}
                    title={<FormattedMessage id={"select-an-order"}/>}
                    description={<FormattedMessage id={"select-an-order.description"}/>}
                />
            </div>
        </OverviewSection>
    );
};

export default EmptyState;